import React, { useContext } from 'react';
import { DaylightContext } from '../DaylightCodeMapper';
import { Button, ModalFooter } from 'reactstrap';
import FinalizePracticeButton from './FinalizePracticeButton';
import DownloadCodeExportButton from './DownloadCodeExportButton';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../../context';

const CodeMapperFooter = () => {
    const dispatch = useDispatch();
    // TODO: make sure this is actually working
    const { canFlagForReview } = useContext(DaylightContext);
    const closeModal = () =>
        dispatch(actions.daylight.toggleDaylightCodeReviewModal())
        .then(() => {
            dispatch(actions.daylight.clearDaylightCodeMapperState());
        });
    return (
        <ModalFooter>
            {canFlagForReview && <FinalizePracticeButton />}
            <DownloadCodeExportButton />
            <Button color="primary" onClick={closeModal}>
                Close
            </Button>
        </ModalFooter>
    );
};

export default CodeMapperFooter;
